import { render } from "./UpdateQuestiontModal.vue?vue&type=template&id=92952824"
import script from "./UpdateQuestiontModal.vue?vue&type=script&lang=js"
export * from "./UpdateQuestiontModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__